<template>
    <Modal :show="true" @close="close">
        <form class="flex flex-col space-y-4" @submit.prevent="submit">
            <h3 class="text-lg font-semibold">
                {{ lang('reservations::schedule.modals.create_slot.title') }}
            </h3>

            <div
                class="px-6 py-3 -mx-6 space-y-4 border-gray-300 bg-gray-50 border-y dark:bg-zinc-800 dark:border-zinc-900"
            >
                <form-body
                    v-model="form"
                    :fields="fields"
                    :reservables="reservables"
                    :calculated-name="calculatedName"
                ></form-body>

                <Field
                    v-show="showAdvanced || massCreate"
                    v-model="form.number"
                    :field="{ name: 'Počet termínů', type: 'number', adminComponent: 'AdminNumber', slug: 'number' }"
                    dusk="form-number"
                />
            </div>

            <fieldset class="px-4 py-2">
                <div class="flex space-x-8">
                    <div class="flex-auto text-center">
                        <Button
                            type="submit"
                            :class="{ 'opacity-75': form.processing }"
                            :loading="form.processing"
                            :disabled="form.processing"
                            dusk="form-submit"
                            color="primary"
                        >
                            {{ lang('reservations::slots.actions.create') }}
                        </Button>
                    </div>
                </div>
            </fieldset>
        </form>
    </Modal>
</template>

<script setup lang="ts">
import { Reservable, ReservationSlot } from '@src/Reservations/Pages/types';
import { useForm } from '@inertiajs/vue3';
import FormBody from '@src/Reservations/Pages/Slots/FormBody.vue';

interface Day {
    reservable_id: number | string;
    reservable_type: string;
    date: string;
}

interface Props {
    reservationSlot?: ReservationSlot;
    reservables: Reservable[];
    fields: Record<string, unknown>;
    day?: Day;
    showAdvanced?: boolean;
    massCreate?: boolean;
    calculatedName?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    reservationSlot: undefined,
    showAdvanced: false,
    massCreate: false,
    calculatedName: false,
    day: () => ({
        reservable_id: null,
        reservable_type: '',
        date: '',
    }),
});

const emit = defineEmits(['close', 'created']);

const close = () => {
    emit('close');
};

const form = useForm({
    id: props.reservationSlot?.id,
    reservable_id: parseInt(props.reservationSlot?.reservable_id, 10),
    reservable_type: props.reservationSlot?.reservable_type,
    name: props.reservationSlot?.name,
    data: props.reservationSlot?.data,
    time_slot_from: props.reservationSlot?.time_slot_from,
    time_slot_to: props.reservationSlot?.time_slot_to,
    number: 1,
});

const submit = () => {
    form.post(route('reservations.slots.create'), {
        preserveScroll: true,
        preserveState: true,
        forceFormData: true,
        onSuccess: () => emit('created'),
        onStart: () => ({}),
        onFinish: () => emit('close'),
    });
};
</script>
